/* Haulage Contractors — standalone page (parity with Pump Companies). Owner-drivers and cartage
   firms that run trucks for you but don't own a plant. Wraps the same ContractorsPanel used on the
   Fleet page (single source of truth): register them, invite their login, link their trucks; each
   gets a private live map of their own trucks + ETAs. */
import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import ContractorsPanel from "@/components/ContractorsPanel";

export default function Haulage() {
  const [contractors, setContractors] = useState([]);
  const load = useCallback(() => api.get("/contractors").then((r) => setContractors(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-6 lg:p-8" data-testid="haulage-page">
      <ContractorsPanel contractors={contractors} reload={load} />
    </div>
  );
}
